module.exports = __webpack_public_path__ + "static/madratdead-83a50ea9274bf34b6e7200771d6f2654.jpg";